import React from "react";
import DestinationPageData from "./DestinationPageData";
import useAppContext from "../../../context/useAppContext";
import { useMergeFlag, MergeFlagFeature } from "../../../shared/hooks/useMergeFlag";
import { useHistory } from "react-router-dom";
import { CONFIGURATION_WEBHOOKS_EMITTERS_PATH } from "../../../../router/RouterUtils";
import { SectionHeaderWrapper } from "../../../shared/SectionHeaderWrapper";

const ConfigurationDestinations = () => {
  // hooks
  const { user } = useAppContext();
  const history = useHistory();

  if (!user.is_destinations_enabled) {
    history.replace(CONFIGURATION_WEBHOOKS_EMITTERS_PATH);
  }

  return (
    <SectionHeaderWrapper
      title="Destinations"
      subtitle="Your data stores that Merge can write data into."
    >
      <DestinationPageData />
    </SectionHeaderWrapper>
  );
};

export default ConfigurationDestinations;
